import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom/client'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import Dashboard from './components/Dashboard'
import Stage from './components/Stage'
import { Auth } from './contexts/Auth'
import { initializeFirebase } from './helpers/firebase'
import { initializeMixpanel } from './helpers/mixpanel'
import { initializeSentry } from './helpers/sentry'
import './index.css'

initializeMixpanel()
initializeSentry()
initializeFirebase()

const StageNotifier = () => {
  const [stageView, setStageView] = useState(false)
  const [message, setMessage] = useState('')
  const [flash, setFlash] = useState(false)

  const message_ref = firebase.database().ref('message')
  const flash_ref = firebase.database().ref('flash')

  useEffect(() => {
    // ensure that the message is not flashing on init
    flash_ref.set(false)
    message_ref.on('value', snapshot => setMessage(snapshot.val()))
    flash_ref.on('value', snapshot => setFlash(snapshot.val()))
    return () => {
      message_ref.off('value')
      flash_ref.off('value')
    }
  }, []) // eslint-disable-line

  return stageView ? (
    <Stage message={message} flash={flash} setStageView={setStageView} />
  ) : (
    <Dashboard
      message={message}
      message_ref={message_ref}
      flash={flash}
      flash_ref={flash_ref}
      setStageView={setStageView}
    />
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Auth>
    <StageNotifier />
  </Auth>
)
